<template>
    <div class="card">
        <div class="card card-custom" >
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <h3 class="card-label">{{ $t('setting.imap') }}</h3>
            </div>
          </div>
          <form @submit.prevent="submitForm" class="form">
            <div class="modal-content">
              <div class="modal-body">
                <RequiredText />

                <fieldset class="mb-5 mt-5">
                  <legend class="mb-3 fs-2x fw-bold">Serveur entrant (IMAP)</legend>
                <div class="row">
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`incoming-host`"
                      type="text"
                      :label="$t('setting.imap_host')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.imap_host')"
                      v-model="formData.incoming.host"
                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`incoming-port`"
                      type="number"
                      :min="0"
                      :label="$t('setting.imap_port')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.imap_port')"
                      v-model="formData.incoming.port"
                  />
                  <Input
                      containerClass="col-12 col-md-6 mt-auto mb-10"
                      :name="`incoming-encryption`"
                      type="text"
                      :label="$t('setting.encryption')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      :isRequired="true" size="lg"
                      :placeholder="$t('setting.encryption')"
                      v-model="formData.incoming.encryption"
                  />
                </div>
                </fieldset>

                <fieldset>
                  <legend class="mb-3 fs-2x fw-bold">Serveur sortant (SMTP)</legend>
                  <div class="row">
                    <Input
                        containerClass="col-12 col-md-6 mt-auto mb-10"
                        :name="`outgoing-host`"
                        type="text"
                        :label="$t('setting.imap_host')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        :isRequired="true" size="lg"
                        :placeholder="$t('setting.imap_host')"
                        v-model="formData.outgoing.host"
                    />
                    <Input
                        containerClass="col-12 col-md-6 mt-auto mb-10"
                        :name="`outgoing-port`"
                        type="number"
                        :min="0"
                        :label="$t('setting.imap_port')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        :isRequired="true" size="lg"
                        :placeholder="$t('setting.imap_port')"
                        v-model="formData.outgoing.port"
                    />
                    <Input
                        containerClass="col-12 col-md-6 mt-auto mb-10"
                        :name="`outgoing-encryption`"
                        type="text"
                        :label="$t('setting.encryption')"
                        labelClass="form-label fs-6 text-black"
                        :inputClass="'form-control form-control-lg form-control-solid'"
                        :isRequired="true" size="lg"
                        :placeholder="$t('setting.encryption')"
                        v-model="formData.outgoing.encryption"
                    />
                  </div>
                </fieldset>

              </div>
              <div class="modal-footer">
                <Button v-if="$can(abilities.EMAIL_CONFIG_CREATE)" btn-class="btn-sm" type="submit" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
  </template>
  
<script setup>
  import {computed, onMounted, ref,watch} from "vue";
  import Input from "@/components/Input.vue";
  import RequiredText from "@/components/RequiredText"
  import Button from "@/components/Button"
  import i18n from '@/plugins/i18n';
  import {useStore} from "vuex";
  import abilities from "@/composables/abilities";

  const store = useStore()
  const isLoading = ref(false)
  const formData = ref({
    incoming: {
      host: '',
      port: '',
      encryption: '',
    },

    outgoing: {
      host: '',
      port: '',
      encryption: '',
    }
  })

  async function submitForm(){(formData.value)
    try {
      isLoading.value = true;
     /* formData.value.society_id = currentSociety.value?.id*/
      await store.dispatch('mails/setImapConfig', formData.value).then((res) =>{
        /*formData.value.password = ''*/

        window.toastr['success'](i18n.global.t('mail.config_successfully'))
      }) 
    } catch (error) {
    } finally {
      isLoading.value = false;
    }
  }

  onMounted(async() => {
    await store.dispatch('mails/getImapConfig').then((res) => {
      let data = res.data
      if(data?.incoming){
        formData.value.incoming.host = data.incoming.host
        formData.value.incoming.port = data.incoming.port
        formData.value.incoming.encryption = data.incoming.encryption
      }

      if(data?.outgoing){
        formData.value.outgoing.host = data.outgoing.host
        formData.value.outgoing.port = data.outgoing.port
        formData.value.outgoing.encryption = data.outgoing.encryption
      }
    })
  })
</script> 